module.exports = ".card img{\r\n    width:100%;\r\n    height: 150px;\r\n  -o-object-fit: cover;\r\n     object-fit: cover;\r\n}\r\n.input-group-btn:last-child>.btn{\r\n  z-index: 1 !important;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/store/store.component.css
// module id = ./src/app/store/store.component.css
// module chunks = main